<template>
  <div>
    <!-- Splash Screen -->
    <div v-if="!splashClicked" class="splash-screen">
      <div class="splash-side splash-left" @click="handleSideClick('left')">
      </div>
      <div class="splash-center">
        <h2 class="lunacali-logo">
          lunacali
        </h2>
      </div>
      <div class="splash-side splash-right" @click="handleSideClick('right')">
      </div>
    </div>

    <!-- Main App Content -->
    <div v-show="splashClicked">
      <Navbar v-show="loaded || noLoadRequired" />

      <div v-if="!loaded && !noLoadRequired" class="load-waiter" />

      <div v-show="loaded || noLoadRequired" ref="app" id="app">
        <transition :name="routerTransition">
          <router-view
            @show-snackbar="showSnackbar"
            @load-finish="loaded = true"
            class="router-view"
          />
          <span
            class="app-background"
            style="background-color: black; height: 100vh; width: 100vw;"
          ></span>
        </transition>

        <div ref="snackbar" id="snackbar"></div>
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
export default {
  el: "application",
  data: function() {
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    return {
      message: "Hello Vue!",
      session: null,
      firstLoad: true,
      loaded: false,
      splashClicked: isLocalhost,
      clickPattern: [],
      passwordPattern: ['left', 'right', 'right', 'left', 'right', 'right', 'right', 'left', 'left'],
      blogImageUrl:
        "https://bitcoinist.com/wp-content/uploads/2019/03/shutterstock_560802985.jpg",
    };
  },
  mounted() {
    this.startSession();

    window.addEventListener("beforeunload", (event) => {
      this.finishSession();
    });

    this.listenToAdmin();
    this.listenToArrowKeys();
  },
  computed: {
    showBanner() {
      return this.$route.path === "/home";
    },
    noLoadRequired() {
      return this.$route.path !== "/";
    },
    routerTransition() {
      if (this.$route.path === "/") {
        return "";
      } else {
        return "router-fade";
      }
    },
  },
  methods: {
    listenToAdmin() {
      document.addEventListener("keydown", (event) => {
        if (event.keyCode === 13 && event.ctrlKey && event.shiftKey) {
          window.location = "/admin-login";
        }
      });
    },
    listenToArrowKeys() {
      document.addEventListener("keydown", (event) => {
        if (!this.splashClicked) {
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.handleSideClick('left');
          } else if (event.key === "ArrowRight") {
            event.preventDefault();
            this.handleSideClick('right');
          }
        }
      });
    },
    async startSession() {
      const url = `/client/sessions`;

      const response = await axios.post(url, {
        readerKey: localStorage.readerKey,
      });

      if (response.data.admin) this.$store.commit("upgradeToAdmin");

      this.$store.commit("setSessionId", response.data.id);
      localStorage.readerKey = response.data.readerKey;
    },
    finishSession() {
      axios.delete(`/client/sessions/${this.$store.getters.sessionId}`);
    },
    showSnackbar(status, message) {
      snackbar.innerHTML = message;
      snackbar.classList.remove("success", "failure");
      snackbar.classList.add(status, "show");

      setTimeout(function() {
        snackbar.classList = "";
      }, 3000);
    },
    handleSideClick(side) {
      this.clickPattern.push(side);

      // Check if the last 9 clicks match the password
      if (this.clickPattern.length >= 9) {
        const lastNine = this.clickPattern.slice(-9);
        const matches = lastNine.every((click, index) => click === this.passwordPattern[index]);

        if (matches) {
          this.splashClicked = true;
        }
      }
    },
  },
  watch: {
    $route: function(to, from) {},
  },
};
</script>

<style lang="scss">
@import "./packs/stylesheets/base/variables";

a:link,
a:active,
a:visited,
a:hover {
  text-decoration: none;
}

.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  z-index: 9999;
}

.splash-side {
  flex: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.02);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.05);
  }
}

.splash-center {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.splash-logo {
  color: rgba(230, 230, 230, 1);
  font-size: 120px;
  font-weight: 400;
  margin: 0;
  user-select: none;

  @media screen and (max-width: 768px) {
    font-size: 70px;
  }
}

.admin-padding {
  padding: 160px;
}

.load-waiter {
  background-color: black;
  height: 100vh;
}

.home-image-place {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #161616;
}

.home-image {
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
}

#app {
  position: relative;
  min-height: 100vh;

  background: black;
}

.router-view {
  background: black;
}

@media screen and (max-width: 1400px) {
  .router-view {
  }
}

@media screen and (max-width: 768px) {
  #app {
    padding: 0 0 10px;
  }

  .router-view {
    padding: 0;
  }
}
</style>
